import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "folder-container" }
const _hoisted_2 = {
  key: 0,
  class: "folder-children-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "folder-text-div",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(!_ctx.open)))
    }, [
      _createElementVNode("div", null, _toDisplayString(`${_ctx.open ? '﹀' : '〉'}`), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}